// SPDX-License-Identifier: AGPL-3.0-or-later

interface PositionedEmojiCategory {
	readonly id: string;
	readonly position: number;
}

// Snowflake ids are unsigned 64-bit integers serialized as decimal strings; comparing them as
// strings (e.g. localeCompare) does not match the server's numeric tie-break in GuildEmojiCategoryService.
export function compareGuildEmojiCategoriesByPosition(a: PositionedEmojiCategory, b: PositionedEmojiCategory): number {
	if (a.position !== b.position) return a.position - b.position;
	if (a.id === b.id) return 0;
	return BigInt(a.id) < BigInt(b.id) ? -1 : 1;
}
